// Validation function to prevent SSRF attacks
const validateFilePath = (path: string): boolean => {
  const allowedPathRegex = /^[a-zA-Z0-9\-_.\/ ()]+$/;

  if (path.includes('..') || path.includes('//')) {
    return false;
  }

  if (path.includes('://') || path.startsWith('//')) {
    return false;
  }

  return allowedPathRegex.test(path) && path.length > 0 && path.length < 500;
};

export default validateFilePath;
